import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const MyCalendar = () => {
  const [currentDate, setCurrentDate] = useState(new Date()); 

  const monthNames = [
    'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
  ];

  const dayNames = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();

    // Décale le jour de la semaine pour commencer par lundi (0 = lundi, 6 = dimanche)
    let startingDayOfWeek = firstDay.getDay() - 1;
    if (startingDayOfWeek < 0) startingDayOfWeek = 6;

    const days = [];

    // Jours du mois précédent
    const prevMonth = new Date(year, month, 0);
    const prevMonthDays = prevMonth.getDate();
    for (let i = startingDayOfWeek - 1; i >= 0; i--) {
      days.push({
        day: prevMonthDays - i,
        isCurrentMonth: false,
        isNextMonth: false
      });
    }

    // Jours du mois courant
    for (let day = 1; day <= daysInMonth; day++) {
      days.push({
        day,
        isCurrentMonth: true,
        isNextMonth: false
      });
    }

    // Jours du mois suivant
    const totalCells = Math.ceil(days.length / 7) * 7;
    let nextMonthDay = 1;
    for (let i = days.length; i < totalCells; i++) {
      days.push({
        day: nextMonthDay,
        isCurrentMonth: false,
        isNextMonth: true
      });
      nextMonthDay++;
    }

    return days;
  };

  const navigateMonth = (direction) => {
    setCurrentDate(prev => {
      const newDate = new Date(prev);
      newDate.setMonth(prev.getMonth() + direction);
      return newDate;
    });
  };

  const days = getDaysInMonth(currentDate);
  const monthYear = `${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`;

  return (
    <div className="max-w-md w-full mx-auto font-sans px-2 pb-2">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <button
          onClick={() => navigateMonth(-1)}
          className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gray-100 hover:bg-[#0C5B6D]/10 flex items-center justify-center transition-colors"
          aria-label="Mois précédent"
        >
          <ChevronLeft className="w-5 h-5 text-[#0C5B6D]" />
        </button>
        
        <h2 className="text-lg sm:text-xl font-semibold text-[#0C5B6D] tracking-wide">
          {monthYear}
        </h2>
        
        <button
          onClick={() => navigateMonth(1)}
          className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gray-100 hover:bg-[#0C5B6D]/10 flex items-center justify-center transition-colors"
          aria-label="Mois suivant"
        >
          <ChevronRight className="w-5 h-5 text-[#0C5B6D]" />
        </button>
      </div>

      {/* Days of week header */}
      <div className="grid grid-cols-7">
        {dayNames.map((day) => (
          <div key={day} className="text-center py-1 sm:py-2">
            <span className="font-medium text-[#0C5B6D] text-xs sm:text-sm">{day}</span>
          </div>
        ))}
      </div>

      {/* Calendar grid */}
      <div className="grid grid-cols-7 gap-1 sm:gap-2">
        {days.map((dateObj, index) => {
          const isToday =  dateObj.isCurrentMonth &&
            dateObj.day === new Date().getDate() &&
            currentDate.getMonth() === new Date().getMonth() &&
            currentDate.getFullYear() === new Date().getFullYear();

          return (
            <div
              key={index}
              className="aspect-square flex items-center justify-center relative"
            >
              <span
                className={`
                  text-base sm:text-sm w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center
                  ${!dateObj.isCurrentMonth 
                    ? 'text-gray-300' 
                    : isToday 
                      ? 'bg-[#0C5B6D] text-white font-semibold'
                      : 'text-black hover:bg-[#0C5B6D]/10'
                  }
                  transition-colors cursor-pointer
                `}
              >
                {dateObj.day}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MyCalendar;